<template>
  <div class="flex h-full flex-col gap-2 rounded border p-3">
    <div class="flex flex-row items-center">
      <div class="flex flex-1 flex-col">
        <h3 class="text-xl leading-none font-bold">
          <RouterLink
            :to="{
              name: 'supplier_order_page_route_id',
              params: {
                supplierOrderId: supplierOrder.id
              }
            }"
          >
            {{ supplierOrder.recipient?.name }}
          </RouterLink>
        </h3>
        <span v-if="supplierOrder?.reference" class="text-xl text-slate-700">
          {{ supplierOrder.reference }}
        </span>
      </div>
      <div class="flex items-start gap-2 text-xs font-semibold">
        <template v-if="!isSupplierOrderClosedOrCancelled">
          <BaseButton
            :title="$t('button.closed')"
            icon="archive"
            size="extra-small"
            theme-color="border-slate-600 bg-white text-slate-700 hover:bg-slate-600 hover:text-white"
            @click="closeSupplierOrder"
          />
          <BaseButton
            :title="$t('button.cancel')"
            icon="ban"
            size="extra-small"
            theme-color="border-orange-500 bg-white text-orange-600 hover:bg-orange-500 hover:text-white"
            @click="cancelSupplierOrder"
          />
        </template>
        <span
          :data-tint="supplier_order_status?.bg_color"
          class="rounded border border-primary bg-primary px-1 py-0.5 text-contrast-primary"
        >
          {{ supplier_order_status?.name }}
        </span>
        <span class="rounded border border-slate-600 px-1 py-0.5">
          {{ supplierOrder.supplier_order_items_count }}
          {{
            supplierOrder.supplier_order_items_count > 1
              ? $t('attributes.items')
              : $t('attributes.item')
          }}
        </span>
      </div>
    </div>

    <div class="flex flex-col text-sm text-slate-800">
      <div v-if="supplierOrder.delivery_model.name">
        <FontAwesomeIcon :icon="['fal', 'location-dot']" class="w-6" />
        <span>
          {{ supplierOrder?.delivery_model.name }}
        </span>
      </div>
      <div v-if="supplierOrder.delivery_date_time">
        <FontAwesomeIcon :icon="['fal', 'truck-clock']" class="w-6" />
        <span class="capitalize">
          {{
            $h.formatDate(
              supplierOrder.delivery_date_time,
              'LLLL',
              $i18n.locale.substring(0, 2)
            )
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapActions, mapGetters } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import { isClosedOrCancelled } from '@/assets/enums/supplierOrder/SupplierOrderStatus'

export default {
  name: 'SupplierOrderSummary',
  components: { FontAwesomeIcon, BaseButton },
  props: {
    supplierOrder: {
      type: Object,
      required: true
    }
  },
  emits: ['refresh'],
  computed: {
    ...mapGetters({
      supplier_order_statuses: 'metadata/getMetadataSupplierOrderStatuses'
    }),
    supplier_order_status() {
      return this.supplier_order_statuses.find(
        (supplier_order_status) =>
          supplier_order_status.id === this.supplierOrder.status
      )
    },
    isSupplierOrderClosedOrCancelled() {
      return isClosedOrCancelled(this.supplierOrder.status)
    }
  },
  methods: {
    ...mapActions({
      processCloseSupplierOrderAction: 'supplierOrder/closeSupplierOrder',
      processCancelSupplierOrderAction: 'supplierOrder/cancelSupplierOrder'
    }),
    closeSupplierOrder() {
      this.processCloseSupplierOrderAction({
        supplier_order_id: this.supplierOrder.id
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.updated_m', {
            var: this.$t('global.supplier_order')
          })
        )
        this.$emit('refresh')
      })
    },
    cancelSupplierOrder() {
      this.processCancelSupplierOrderAction({
        supplier_order_id: this.supplierOrder.id
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.updated_m', {
            var: this.$t('global.supplier_order')
          })
        )
        this.$emit('refresh')
      })
    }
  }
}
</script>
